import React, {Component,Fragment} from 'react';
import PropTypes from 'prop-types'
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import {BeatLoader} from 'react-spinners';
import StepZilla from "react-stepzilla";
import {_addNotification,_addNotificationError} from './../../../../server/util';
import {lunchBreakfastModal,personModal,personType,incomeModal, IncomFreqency}from './../../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import {get} from "./../../../../server/actions"
import Select,{components} from 'react-select';
import makeAnimated from 'react-select/animated';
import Welcome from './../../../Parent/SchoolLunchBreakfastProgram/welcome';
import W_FirstParentInfo from './w_firstParentInfo';
import W_SchoolSelect from './w_selectStudent'
import AssistanceProgram from './assistancePrograms';
import FosterQualify from './fosterQualify';
import MigrantQualify from './migrantQualify';
import IncomeOption from './incomeOption';
import AddChild from './addChild';
import AddAdult from './addAdult';
import AddChildIncome from './addChildIncome';
import AddAdultIncome from './addAdultIncome';
import AddressDetails from './addressDetails';
import RacialEthnic from './racialEthnic';
import SSN from './ssn';
import Agreement from './agreement';
import W_summaryReport from './w_summaryReport'; 
import FreeReducedProgramFAQ from './../../../Parent/SchoolLunchBreakfastProgram/freeReducedProgramFAQ'
import StepFinal from './stepFinal';
import StudentsSearch from './studentsSearch';
import './faqSidepan.css'
import BeforeBegin from './beforeBegin';
import { translate, Trans} from "react-i18next";

const animatedComponents = makeAnimated();

class NewLunchApplication extends Component {
  constructor(props) {
    super(props)
    this.state={
      schoolList:[],
        loading:false,
        initStep:2,
        showStepWizard:false,
        appliedStudents:[],
        sourceFrom:'',
        lunchBreakfastObj: JSON.parse(JSON.stringify({...lunchBreakfastModal,childList:[],adultList:[]})),
        schoolInfo:{id:0,name:'',sessionYear:'',schoolPdfUrl:''},
        showDropDown:false,
        inPermId:0,
        inPermType:'',

        allStudentList:[],
        otherStudents:[],
        selectedStudent:{},
        otherSelectedStudents:[],
        isChecked: false
    }
}
initData=()=>{
    this.getStudentList()
}
componentDidMount=()=>{
  this._notificationSystem = this.refs.notificationSystem;
  this.initData();
}

buildApplicationUI=(content, appData, trans)=>{
    if(Object.keys(appData).length>0){
    let mainDev=document.createElement('div');
    let title=document.createElement('div');
    let heading=document.createElement('h3');
    heading.innerHTML=trans("Household Application for Free and Reduced Price School Meals");
    heading.style.color='red';
    heading.style.textAlign='center';
    title.appendChild(heading);
    mainDev.appendChild(title);

    let appNo_date=document.createElement('div');
    let leftDiv=document.createElement('div');
    leftDiv.style.cssFloat='left';
    leftDiv.style.maxWidth='50%';
    leftDiv.innerHTML='<p><strong>'+trans('Application Id')+':</strong></p>';
    appNo_date.appendChild(leftDiv);

    let rightDiv=document.createElement('div');
    rightDiv.style.cssFloat='right';
    rightDiv.style.textAlign='right';
    rightDiv.style.maxWidth='50%';
    rightDiv.innerHTML='<p>'+trans('Date')+': <strong>'+moment(appData.date,'MMDDYYYY').format('MM-DD-YYYY')+'</strong></p>';
    appNo_date.appendChild(rightDiv);
    mainDev.appendChild(appNo_date);

    let childDiv=document.createElement('div');
    let childTable='<table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
    let childHead='<thead><tr>'+
            '<th rowspan="2" style="width:20%">'+trans('First Name')+'</th>'+
            '<th rowspan="2" style="width:20%">'+trans('Last Name')+'</th>'+
            '<th rowspan="2" style="width:7%">'+trans('Grade')+'</th>'+
            '<th colspan="2" style="width:15%">'+trans('Student?')+'</th>'+
            '<th rowspan="2" style="width:10%">'+trans('Foster Child')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('Runaway Program')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('McKinney-Vento Homeless')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('Migrant Education Program')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('Head Start')+'</th>'+
            '</tr><tr>'+
            '<th>'+trans('Yes')+'</th>'+
            '<th>'+trans('No')+'</th>'+
            '</tr></thead>';
    let childStudents='';
    (appData.householdAppInfo||[]).map((student)=>{
            if(student.personType===personType.student){
               /*  let homelessString='';
                if( student.runaway){
                    (student.homelessOrMigrantOrRunawayOptions||[]).map(itm=>{
                        homelessString=homelessString+ '<span>&#10003;</span> <span>'+itm+'</span><br />';
                    });
                } */
                childStudents=childStudents+'<tr><td>'+student.fname+'</td>'+
                '<td>'+student.lname+'</td>'+
                '<td>'+student.grade+'</td>'+
                '<td style="text-align:center">'+(student.personType===personType.student?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.personType!==personType.student?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.liveUnderFosterCare?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.runaway?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.mcKinneyVentoHomeless?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.migrantEducationPrg?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.headStart?'<span>&#10003;</span>':'')+'</td></tr>';
            }
    });
    let childs='';
    (appData.householdAppInfo||[]).map((student)=>{
        if(student.personType===personType.child){
           /*  let homelessString='';
                if( student.runaway){
                    (student.homelessOrMigrantOrRunawayOptions||[]).map(itm=>{
                        homelessString=homelessString+ '<span>&#10003;</span> <span>'+itm+'</span><br />';
                    });
                } */
            childs=childs+'<tr><td>'+student.fname+'</td>'+
            '<td>'+student.lname+'</td>'+
            '<td>'+student.grade+'</td>'+
            '<td style="text-align:center">'+(student.personType===personType.student?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.personType!==personType.student?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.liveUnderFosterCare?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.runaway?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.mcKinneyVentoHomeless?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.migrantEducationPrg?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.headStart?'<span>&#10003;</span>':'')+'</td></tr>';
        }
    });
    let programDev=document.createElement('div');
    let programLbl='<p style="font-size: 12px;"><strong>'+trans('Do any Household Members (including you) currently participate in one or more of the following assistance programs')+': SNAP, TANF, or FDPIR?'+'</strong></p>'+'<table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
    let programList='';
    ((appData.householdAppInfo[0]||{}).assistancePrograms||[]).map((program,p)=>{
        programList=programList+'<tr style="font-size: 12px;"><td style="width:50%"><strong>'+trans(program.name)+' :</strong></td><td><label>'+program.caseNumber+'</label></td></tr></tr>'
    })
    programDev.innerHtml=programLbl+programList+'</table>';
    
    let incomeDev=document.createElement('div');  

    let incomeBody='';
    let isIncomeExist=(appData.householdAppInfo||[]).some((person)=>{
        return person.income.length>0;
    });
    if(isIncomeExist){
        let incomeHeader='<p style="font-size:14px;  margin:5px 0px;"><strong>'+trans('Report Income for ALL Household Members')+'</strong></p><table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">'+
    '<tr><th rowspan="2">'+trans('Name')+'</th><th colspan="3" style="text-align:center;">'+trans('Income') +'($)</th></tr><tr><th>'+trans('Source')+'</th><th>'+trans('Frequency')+'</th><th>'+trans('Amount')+ '($)</th></tr>';
        appData.householdAppInfo.map((person)=>{
            if(person.income.length>0){
                incomeBody=incomeBody+'<tr><td rowspan='+(person.income.length+1)+'>'+person.fname+' '+person.lname+'</td><td colspan="3" style="padding:0; border:0;"></td></tr>'
                person.income.map(income=>{
                    incomeBody=incomeBody+'<tr><td>'+income.source+'</td><td>'+ this.getFrequencyName(income.frequency)+'</td><td>'+income.amount+'</td></tr>' 
                })
            }
        })
        incomeDev.innerHTML=incomeHeader+'<tbody>'+incomeBody+'</tbody>'+'</table>';
    }
    let addressDev='<p style="font-size:14px;  margin:5px 0px;"><strong>'+trans('Contact information')+'</strong></p>'+
    '<div class="table-responsive"><table width="100%" style="font-size:12px"><tr><td><span><strong>'+trans('Email')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.email+
    '</span></td><td><span><strong>'+trans('Phone')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.phone+
    '</span></td><td><span><strong>'+trans('Address 1')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.street1+'</span></td></tr>'+
    '<tr><td><span><strong>'+trans('Address 2')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.street2+
    '</span></td><td><span><strong>'+trans('City')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.city+'</span></td>'+
    '<td><span><strong>'+trans('State')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.state+'</span></td></tr>'+
    '<tr><td><span><strong>'+trans('Zip')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.zip+'</span></td><td></td><td></td></tr>'+
    '</table></div>';
    let ssnDev='<p style="font-size:12px"><strong>'+trans('Last Four Digits of Social Security Number (SSN) of Primary Wage Earner or Other Adult Household Member')+'</strong>'+
    ': '+(appData.householdAppInfo[0].noSSN===true? 'No SSN': appData.householdAppInfo[0].ssn)+'</p>';

    let racialDev="<p style='font-size:14px;  margin:5px 0px;'><strong>"+trans("Children's Racial and Ethnic Identities")+"</strong></p>";
    racialDev=racialDev+'<table border=1 width="100%" style="border-collapse: collapse; border: 1px solid #ddd;font-size:12px"><tr><th style="width:25%">'+trans('Name')+'</th><th style="width:25%">'+trans('Ethnicity')+'</th><th>'+trans('Race')+'</th></tr>'
    appData.householdAppInfo.map((student)=>{
        if(student.personType===personType.student){
            racialDev=racialDev+'<tr><td>'+student.fname+' '+student.lname+
            '</td><td>'+(student.ethenticity||"")+'</td><td>'+(student.race||[]).join(', ')+'</td></tr>';
        }
    });
    racialDev=racialDev+'</table>';
    //let houseHoldDiv= this.getTotalIncome(appData.householdAppInfo)>0?('<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Income per Annum ($) : </strong></span><span>'+this.getTotalIncome(appData.householdAppInfo)+'</sp></p>'):''+ '';
    // '<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Size : </strong></span><span>'+appData.householdAppInfo.length+'</span></p>';
    
    let applicentDev='<div style="padding:10px; float:right"><p style="text-align:left;margin: 2; padding-bottom:5px;padding-top:10px; font-size: 14px;">'+trans('Submitted By')+',</p>'+
    '<strong style="text-align: left;display: block;font: 16px bold;text-transform: uppercase;">'+appData.householdAppInfo[0].fname+' '+appData.householdAppInfo[0].lname+'</stro>'
    +'<span style="text-align: left;display: block;font: 13px italic;">'+trans('Date')+':'+moment(appData.date,'MMDDYYYY').format('YYYY-MM-DD HH:MM:SS')+'</span></div>'
    childDiv.innerHTML=childTable+childHead+
    '<tbody>'+childStudents+childs+
    '</tbody></table>'+programDev.innerHtml+incomeDev.innerHTML+
    addressDev+ssnDev+racialDev+
    //houseHoldDiv+
    applicentDev;
    mainDev.appendChild(childDiv);

    content.innerHTML = mainDev.outerHTML;
}
}
getFrequencyName=(freq)=>{
    let frequency= IncomFreqency.find(inf=>{
         return inf.value==freq;
     });
     return((frequency||{}).text||'');
 }
 getAnnualIncome=(Income)=>{
    let amount=0.00;
    Income.map(inc=>{
        amount=amount+(parseInt(inc.frequency)* parseFloat(inc.amount))
    });    
    return amount;
}
getTotalIncome=(students)=>{
    let amount=0.00;
    students.map((student)=>{
        amount=amount+this.getAnnualIncome(student.income);
    });
    return amount
}
getStudentList=()=>{
    const _selectedStudentData= (this.context.router.route.location.state||{});
    this.setState({ loading: true });
    const loginUserInfo=JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
    let schoolId = sessionStorage.getItem('SchoolId');
    get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=')
    .then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }).then(data => { 
        console.log("Data11111111::::::",data);
        let source='A';
        if( Object.keys(_selectedStudentData).length>0){

            const otherStudentList=((data._embedded||{}).studentUsers||[]).filter(std=>{
                return (std.parentuser.userName==_selectedStudentData.parentuser.userName && std.displayRecId!=_selectedStudentData.displayRecId)
            })
            source='M';
            this.setState({selectedStudent:{..._selectedStudentData},otherStudents:otherStudentList||[]});
        }
        console.log("this.state.lunchBreakfastObj::::::",this.state.lunchBreakfastObj);
        this.setState({
            allStudentList:((data._embedded||{}).studentUsers||[]), 
            loading: false,  
            sourceFrom:source,         
            lunchBreakfastObj:{...this.state.lunchBreakfastObj, mealSchoolId:schoolId}, 
            schoolInfo:{...this.state.schoolInfo, id:schoolId, name:loginUserInfo.schoolName, schoolYear: sessionStorage.getItem('schoolYearValue')}
        });
    }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get School data response', error)
            }
        );
}
hideMenu=()=>{
    this.setState({showDropDown:false});
}
updateLunchObj = (newData) => {
    this.setState({ lunchBreakfastObj: newData });
  }

  getSaveData=(rec)=>{
    console.log("selectedItem rec::::::",rec);
    console.log("Props Obj::::",this.props);
    console.log("State Obj::::",this.state);
    //let _lunchBreakfastObj=this.props.lunchObj;
    this.setState({ loading: true });
   // const suchoolYearValue = this.state.schoolObject.sessionYear.schoolYearValue
   get('/getHouseholdAppById?parentEmail=' + rec.parentuser.userName +"&access_token=")
    .then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }).then(data => {
        console.log("Draft Data:::::::::::",data);
        data["persons"] = data["householdAppInfo"].filter(item => (item.personType === "Adult" && item.contact !== null));
        data["studentList"] = data["householdAppInfo"].filter(item => item.personType === "Student");
        console.log("StudentList:::::::",data["studentList"]);
 //       let index = data["studentList"].findIndex(record => record.studentRecId.toString() === student.studentRecId);
//             //console.log("Index::::::",index);
//             if (index !== -1) {
        data["studentList"].map((student,k)=>{
            console.log("student.studentRecId::::::::",student.studentRecId);
            //console.log("student.studentRecId::::::::",student.studentRecId);
            let index = this.state.otherStudents.findIndex(record => record.displayRecId === student.studentRecId);
            console.log("Index:::::",index);
            if (index !== -1) {
                this.setState({isChecked: true});
                this.state.otherSelectedStudents.push(this.state.otherStudents[index]);
            }
            console.log("this.state.otherSelectedStudents::::::::::",this.state.otherSelectedStudents);
            student.isSelected=true;
        });
        data["childList"] = data["householdAppInfo"].filter(item => item.personType === "Child"&&item.mealSchoolId==null);
        data["adultList"] = data["householdAppInfo"].filter(item => item.personType === "Adult" && item.contact === null);
        console.log("this.props.lunchobj::::::",this.props.lunchObj);
        data['assistancePrograms'] = data['persons'][0]['assistancePrograms']||this.props.lunchObj.assistancePrograms;
        data['isIncomeAfter'] = data['incomeAfter'];
        data['isAllFoster'] = data['allFoster'];
        console.log("Data::::",data);
        //this.props.updateLunchObj(data);
        this.setState({lunchBreakfastObj:data});
        console.log("state.lunchBreakfastObj:::::",this.state.lunchBreakfastObj);
        this.setState({loading: false });
    }).catch(
            (error) => {
                this.setState({ loading: false });
                if(this.state.lunchBreakfastObj.hasOwnProperty('applicationId')){
                    delete this.state.lunchBreakfastObj['applicationId'];
                }
                console.log("No response from get:::::::",this.state.lunchBreakfastObj);
                this.state.lunchBreakfastObj.householdAppInfo = this.state.lunchBreakfastObj.persons;
                //this.setState({lunchBreakfastObj:data});
                //this.props.updateLunchObj(this.props.lunchObj);
                console.log('Get School data response', error)
            }
        );
    }

    render(){
        const { t, i18n } = this.props;
        const changeLanguage = lng => {
          i18n.changeLanguage(lng);
        };
        const {allStudentList, otherStudents, selectedStudent, otherSelectedStudents, sourceFrom}=this.state;
        const steps =[        
        {name:'Welcome',component:<Welcome schoolInfo={{...this.state.schoolInfo}} />},
        {name:'Before you begin', component:<BeforeBegin schoolInfo={{...this.state.schoolInfo}}/>},
        {name:'Parent Info', component:<W_FirstParentInfo lunchObj={this.state.lunchBreakfastObj} 
        schoolInfo={{...this.state.schoolInfo}}
        setLoader={(status)=>{
            this.setState({loading:status});
        }}
        onSubmitParentForm={(data,callback)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
            _lunchBreakfastObj=data;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj},()=>{
                callback()
            })
        }}
            onApplicantFieldChange={(key,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0][key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
        />},
        {name:'Students', component:<W_SchoolSelect lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo}}
            onStudentSelectChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].isSelected=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
            }}
        />},
        {name:"Assistance Programs", component:<AssistanceProgram lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo}}
            onProgramSelectChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.assistancePrograms[index].isApplicable=status;
                    if(!status){
                        _lunchBreakfastObj.assistancePrograms[index].caseNumber='';
                    }
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} onProgramCardNoChanged={(index,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.assistancePrograms[index].caseNumber=value;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj});
            }} /> },
        {name:'Foster Qualify', component:<FosterQualify lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo}}
            onAllFosterSelectChange={(key,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
            _lunchBreakfastObj[key]=status;
            if(status===false){
                    _lunchBreakfastObj.studentList.map((stu,i)=>{
                    if(stu.isSelected===true){
                        _lunchBreakfastObj.studentList[i].liveUnderFosterCare=false
                    }
                });
            }                   
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            onStudentFasterSelectChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].liveUnderFosterCare=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
            }}
        />},
        {name:'Migrant Qualify', component:<MigrantQualify lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo}}
        onMcKinneyVentoProgramStatusChange={(index,status)=>{ 
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].mcKinneyVentoHomeless=status;
                
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} 
        onMigrantEducationStatusChange={(index,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].migrantEducationPrg=status;
                
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} 
        onStudentMigrantStatusChange={(index,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].runaway=status;

                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        onHeadStartStatusChange={(index,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].headStart=status;

                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},
        {name:'Income Option', component:<IncomeOption lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo}}
         onSelectionChange={(key,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj[key]=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
         }} />},
        {name:'Add Child', component:<AddChild lunchObj={this.state.lunchBreakfastObj} 
        schoolInfo={{...this.state.schoolInfo}} onAddNewChild={()=>{
            let newChild=JSON.parse(JSON.stringify(personModal))
            newChild.personType=personType.child;
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            console.log("_lunchBreakfastObj::::::",_lunchBreakfastObj);
            _lunchBreakfastObj.childList.push(newChild);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            console.log("_lunchBreakfastObj:::::",_lunchBreakfastObj);
        }} onDeleteChild={(index)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.childList.splice(index, 1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})

        }} onFieldValueChange={(index,key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.childList[index][key]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},            
        {name:'Add Child Income', component:<AddChildIncome lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo}} 
        onFieldValueChange={(mainIndex,mainKey,subindex,subKey,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income[subindex][subKey]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        addIncome={(mainIndex,mainKey)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.push(Object.assign({},incomeModal));
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        onDeleteIncome={(mainIndex,mainKey,subIndex)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.splice(subIndex,1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        />},
        {name:'Add Adult', component:<AddAdult lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo}}
        onAddNewAdult={()=>{
            let newAdult=JSON.parse(JSON.stringify(personModal))
            newAdult.personType=personType.adult;
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.adultList.push(newAdult);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onDeleteAdult={(index)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.adultList.splice(index, 1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})

        }} onFieldValueChange={(index,key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.adultList[index][key]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
         />},
        {name:'Add Adult Income', component:<AddAdultIncome 
        schoolInfo={{...this.state.schoolInfo}}
        lunchObj={this.state.lunchBreakfastObj}
        onFieldValueChange={(mainIndex,mainKey,subindex,subKey,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income[subindex][subKey]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        addIncome={(mainIndex,mainKey)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.push(Object.assign({},incomeModal));
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        onDeleteIncome={(mainIndex,mainKey,subIndex)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.splice(subIndex,1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}  />},
        {name:'Address Details', component:<AddressDetails lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo}}
        onAddressChange={(key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0].contact[key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},
        {name:'Racial & Ethnic', component:<RacialEthnic lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo}}
        onEthnicChange={(index,key,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index][key]=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onRacialChange={(index,value,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            let raceArray=[]
            if(_lunchBreakfastObj.studentList[index].race.length>0){
                raceArray=_lunchBreakfastObj.studentList[index].race;
            }                
            if(_lunchBreakfastObj.studentList[index].race.includes(value)){                    
                var idx = raceArray.indexOf(value);
                if (idx > -1) {
                     raceArray.splice(idx, 1);
                }          
            }
            if(status){
                raceArray.push(value);
            }  
            _lunchBreakfastObj.studentList[index].race=raceArray              
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},
        {name:'SSN', component:<SSN lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo}}
        onSSNChange={(key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0][key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onNoSSNChange={(key,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0][key]=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}  />},
        {name:'Agreement', component:<Agreement lunchObj={this.state.lunchBreakfastObj} refNotify={this} 
        schoolInfo={{...this.state.schoolInfo}} />},
         {name:'Summery', component:<W_summaryReport lunchObj={this.state.lunchBreakfastObj} refNotify={this} 
         schoolInfo={{...this.state.schoolInfo}} buildHtmlUI={(ele,appObj)=>{
                this.buildApplicationUI(ele,appObj,t);
            }} />},
        {name:"Final", component:<StepFinal goToHome={()=>{
            this.context.router.history.push('/schoolAdmin/schoolMealProgram');

        }} />}
      ];
        return(
        <Fragment>
            <NotificationSystem ref="notificationSystem"/>
            <div className='container' style={{marginTop:'10px'}}>
            <section className=" full-width clearfix">
                <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                </div>
                    <div className="row">
                        <div className="col-md-9 col-sm-12 col-xs-12 sectionTitle">
                            <h2>
                                <span>HOUSEHOLD APPLICATION FOR FREE AND REDUCED PRICE SCHOOL MEALS</span> 
                            </h2>
                        </div>
                        <div className="col-md-3 sectionTitle text-right">
                            <button className=" btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                        e.preventDefault();
                                        let _self=this;
                                        _self.context.router.history.goBack() ;
                                    }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                        </div>
                        
                    </div>
                    <div className="clearfix"></div>
                        <div className='row'>
                            <div className='col-md-12'>
                                {
                                    this.state.showStepWizard?
                                    (
                                        <div className="row">                              
                                            <div className="col-xs-12">
                                                    <StepZilla steps={steps} 
                                                                showNavigation={false}
                                                                nextButtonCls= "btn btn-prev btn-xs bg-color-2 pull-right"
                                                                backButtonCls= "btn btn-next bg-color-4 btn-xs pull-left"
                                                                nextTextOnFinalActionStep= "Save"
                                                                nextButtonText= "Continue"
                                                                prevBtnOnLastStep={false} 
                                                                startAtStep={2}
                                                                showSteps={false}
                                                                preventEnterSubmission
                                                            />
                                                </div>                                                            
                                            </div>
                                    ):
                                    <div className='row'>
                                        < StudentsSearch 
                                        {...{  allStudentList, otherStudents, selectedStudent, otherSelectedStudents, sourceFrom }}
                                        updateLunchObj={this.updateLunchObj} 
                                        //checked={this.state.isChecked} 
                                        onChangeStudent={(rec)=>{
                                            if(rec){
                                            const otherStudentList=allStudentList.filter(std=>{
                                                return (std.parentuser.userName==rec.parentuser.userName && std.displayRecId!=rec.displayRecId)
                                            })
                                            this.setState({
                                                selectedStudent:rec,
                                                otherStudents:otherStudentList||[]
                                            });
                                            this.getSaveData(rec);
                                            }else{
                                                this.setState({
                                                    selectedStudent:undefined,
                                                    otherStudents:[]
                                                });
                                            }
                                        }}
                                        onChangeOtherStudents={(e,rec)=>{
                                            // console.log("otherSelectedStudents0:::::::",otherSelectedStudents);
                                            // this.setState(prevState => {
                                            //     console.log("Checked0::::::::::", prevState.isChecked);
                                            
                                            //     // Toggle the isChecked value
                                            //     const updatedChecked = !prevState.isChecked;
                                            
                                            //     console.log("Checked::::::::::", updatedChecked);
                                            
                                            //     // Return the updated state
                                            //     return { isChecked: updatedChecked };
                                            //   });
                                            // if(this.state.isChecked){
                                            // if(e.target.checked){
                                            //     otherSelectedStudents.push(rec);
                                            // }else{
                                            //     const idx=otherSelectedStudents.findIndex(st=>{
                                            //         return st.displayRecId==rec.displayRecId
                                            //     });
                                            //     if(idx>-1){
                                            //         this.setState({
                                            //             otherSelectedStudents:[...otherSelectedStudents.splice(idx, 1)]
                                            //         })
                                            //     }
                                            // }
                                            // Check if the item is already in the 't' array
                                            const isSelected = otherSelectedStudents.some(item => item.displayRecId === rec.displayRecId);

                                            if (isSelected) {
                                            // If selected, remove it
                                            this.setState(prevState => ({
                                                otherSelectedStudents: prevState.otherSelectedStudents.filter(item => item.displayRecId !== rec.displayRecId)
                                            }));
                                            } else {
                                            // If not selected, add it
                                            const selectedObject = otherStudents.find(item => item.displayRecId === rec.displayRecId);
                                            if (selectedObject) {
                                                this.setState(prevState => ({
                                                    otherSelectedStudents: [...prevState.otherSelectedStudents, selectedObject]
                                                }));
                                            }
                                            }
                                            console.log("otherSelectedStudents:::::::",otherSelectedStudents);
                                        }
                                    }
                                    onSubmitStudentSelection={()=>{
                                        console.log("onSubmitStudentSelection::::::",selectedStudent);
                                        if(Object.keys(selectedStudent||{}).length<=0){
                                            _addNotificationError("Please Select Student",this);
                                            return false;
                                        }else{
                                            const {lunchBreakfastObj, otherSelectedStudents}=this.state;
                                            lunchBreakfastObj.persons[0]['fname']=this.state.lunchBreakfastObj.persons[0]['fname'] || '';
                                            lunchBreakfastObj.persons[0]['lname']=this.state.lunchBreakfastObj.persons[0]['lname'] || '';
                                            lunchBreakfastObj.persons[0]['contact']['email']=selectedStudent.parentuser.userName;
                                            const students=[selectedStudent,...otherSelectedStudents];

                                            if(students.length>0){
                                                lunchBreakfastObj.studentList=[]; 
                                                students.map((student,k)=>{
                                                    let _personModal=JSON.parse(JSON.stringify(personModal));
                                                    _personModal.personType=personType.student;
                                                    _personModal.fname= student.firstName;
                                                    _personModal.lname= student.lastName;
                                                    _personModal.mname= "";
                                                    _personModal.income=[
                                                        //Object.assign({},incomeModal)
                                                    ]
                                                    _personModal.grade= student.gradeName;
                                                    _personModal.studentRecId=student.displayRecId;
                                                    _personModal.id=k;
                                                    _personModal.mealSchoolId=student.mSchoolId;
                                                    _personModal.schoolYear=student.schoolYear;
                                                    _personModal.isSelected=true;
                                                    let index = this.state.lunchBreakfastObj.householdAppInfo.findIndex(record => record.studentRecId === student.displayRecId);
                                                    console.log("this.state.lunchBreakfastObj.householdAppInfo:::",this.state.lunchBreakfastObj.householdAppInfo);
                                                    console.log("Student::::",student);
                                                    console.log("Index::::onsubmit:::::",index);
                                                    if (index !== -1) {
                                                        _personModal.isSelected=true;
                                                        _personModal.ethenticity=this.state.lunchBreakfastObj.householdAppInfo[index]['ethenticity'];
                                                        _personModal.race=this.state.lunchBreakfastObj.householdAppInfo[index]['race'];
                                                        _personModal.liveUnderFosterCare=this.state.lunchBreakfastObj.householdAppInfo[index]['liveUnderFosterCare'];
                                                        _personModal.mcKinneyVentoHomeless=this.state.lunchBreakfastObj.householdAppInfo[index]['mcKinneyVentoHomeless'];
                                                        _personModal.migrantEducationPrg=this.state.lunchBreakfastObj.householdAppInfo[index]['migrantEducationPrg'];
                                                        _personModal.runaway=this.state.lunchBreakfastObj.householdAppInfo[index]['runaway'];
                                                        _personModal.headStart=this.state.lunchBreakfastObj.householdAppInfo[index]['headStart'];
                                                        _personModal.homelessOrMigrantOrRunaway=this.state.lunchBreakfastObj.householdAppInfo[index]['homelessOrMigrantOrRunaway'];
                                                        _personModal.income=this.state.lunchBreakfastObj.householdAppInfo[index]['income'];
                                                     }
                                                    lunchBreakfastObj.studentList.push(_personModal);
                                                })
                                            }
                                            this.setState({lunchBreakfastObj:lunchBreakfastObj, showStepWizard:true});
                                        }
                                    }}
                                         />
                                    </div>                          
                                }
                            </div>
                        </div>
                </section>
            </div>
        </Fragment>)
    }
}
NewLunchApplication.contextTypes = {
    router: PropTypes.object.isRequired
};
export default translate("translations")(NewLunchApplication);


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/index.js